export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_@ant-design_icons-react@1.1.2@@ant-design/icons-react/es/index.js
// module id = 267
// module chunks = 0